@if (nitAliado=='901255144') {
<app-solventa></app-solventa>
}
@if (nitAliado=='900591195') {
<app-excelcredit></app-excelcredit>
}
@if (nitAliado=='901819033') {
<app-bc-conecta-wasticredit></app-bc-conecta-wasticredit>
}